import { useMutation, useQuery, useQueryClient } from "react-query";
import { IQueryOptions } from ".";
import {
  createUserReport,
  getMyUserReports,
  getAllUserReports,
  updateUserReportStatus,
  IQueryUserReportsParams,
} from "../api/user-report.service";
import { ICreateUserReportPayload, UserReportStatus } from "@/common/types/user-report";

export const USER_REPORTS_QUERY_KEYS = {
  MY_REPORTS: "GET_MY_USER_REPORTS",
  ALL_REPORTS: "GET_ALL_USER_REPORTS",
};

export const useGetMyUserReports = (
  page = 1,
  limit = 20,
  options: IQueryOptions = {},
) => {
  return useQuery(
    [USER_REPORTS_QUERY_KEYS.MY_REPORTS, page, limit],
    () => getMyUserReports(page, limit),
    {
      keepPreviousData: true,
      staleTime: 30000,
      ...options,
    },
  );
};

export const useGetAllUserReports = (
  params: IQueryUserReportsParams = {},
  options: IQueryOptions = {},
) => {
  return useQuery(
    [USER_REPORTS_QUERY_KEYS.ALL_REPORTS, params],
    () => getAllUserReports(params),
    {
      keepPreviousData: true,
      staleTime: 10000,
      ...options,
    },
  );
};

export const useCreateUserReport = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (payload: ICreateUserReportPayload) => createUserReport(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_REPORTS_QUERY_KEYS.MY_REPORTS);
        queryClient.invalidateQueries(USER_REPORTS_QUERY_KEYS.ALL_REPORTS);
      },
    },
  );
};

export const useUpdateUserReportStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, status, adminResponse }: { id: string; status: UserReportStatus; adminResponse?: string }) =>
      updateUserReportStatus(id, { status, adminResponse }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_REPORTS_QUERY_KEYS.ALL_REPORTS);
        queryClient.invalidateQueries(USER_REPORTS_QUERY_KEYS.MY_REPORTS);
      },
    },
  );
};
